export default __webpack_public_path__ + "static/media/recaptcha_image.dffbabc5.jpg";